import axios from 'axios';
import * as React from 'react';

import { ApiAppConfig, ApiAppConfigZod } from '@vona/shared';

const AppConfigContext = React.createContext<ApiAppConfig | undefined>(undefined);

export const useAppConfig = (): ApiAppConfig => {
  const context = React.useContext(AppConfigContext);
  if (context === undefined) {
    throw new Error('useAppConfig cannot be called outside AppConfigProvider');
  }
  return context;
};

interface Props {
  children: React.ReactNode;
}

export const AppConfigProvider: React.FC<Props> = ({ children }) => {
  const [appConfig, setAppConfig] = React.useState<ApiAppConfig>();
  const [error, setError] = React.useState<string>();

  React.useEffect(() => {
    axios.get('/api/config').then(async (res) => {
      const parsed = ApiAppConfigZod.safeParse(res.data);
      if (!parsed.success) {
        // eslint-disable-next-line no-console
        console.error('Invalid configuration:', parsed.error);
        throw new Error('Invalid configuration');
      }
      setAppConfig(parsed.data);
      setError(undefined);
    }).catch((err) => {
      // eslint-disable-next-line no-console
      console.error('Unable to load VONA configuration', err);
      setError(err.message);
    });
  }, []);

  if (error) {
    throw new Error(error);
  }

  if (!appConfig) {
    return null;
  }

  return (
    <AppConfigContext.Provider value={appConfig}>
      {children}
    </AppConfigContext.Provider>
  );
};
